import styled from 'styled-components';

export const Container = styled.ol`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 0.25rem;
  text-transform: uppercase;
  font-size: 1.8rem;

  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  /* width: 3rem; */
`;
